import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Calculator/GravelCalculator/gravelCalculator.container"
    ).then((module) => ({
        default: module.GravelCalculator
    }))
);
